import { getIn } from 'seamless-immutable';
import { stringify } from 'query-string';

export const getLink = (product, pfmParams, oneDayDelivery) => {
  const id = getIn(product, ['id'], '');
  const isAdsType = !!getIn(product, ['trackingUrl'], '');

  const queryString = getIn(product, ['queryString'], '');

  if (isAdsType) {
    return `/produto/${id}?${pfmParams}&${queryString}`;
  }

  return `/produto/${id}?${pfmParams}${
    !!pfmParams && !!oneDayDelivery ? '&' : ''
  }${oneDayDelivery}${addOfferIdToQueryString(product)}${addBuyboxTokenToQueryString(product)}`;
};

const addOfferIdToQueryString = product => {
  const offerId = getIn(product, ['offers', 'result', 0, 'offerId']);
  return offerId ? `&offerId=${offerId}` : '';
};

const addBuyboxTokenToQueryString = product => {
  const buyboxToken = product?.offers?.meta?.buyboxToken;

  return buyboxToken ? `&buyboxToken=${buyboxToken}` : '';
};

export const getOneDayDelivery = oneDayDeliveryFiltered => {
  if (!oneDayDeliveryFiltered) {
    return '';
  }

  const oneDayDelivery = {
    oneDayDeliveryFiltered: oneDayDeliveryFiltered,
  };

  return stringify(oneDayDelivery);
};

export const getPfmParams = (match, positionCard) => {
  const params = {
    pfm_carac: match.params.term,
    pfm_page: 'search',
    pfm_pos: 'grid',
    pfm_type: 'search_page',
  };

  if (positionCard > 0) {
    params.pfm_index = positionCard;
  }

  return stringify(params);
};

export const getPfmParamsAds = (positionCard, position, publication, pageType) => {
  const params = {
    pfm_type: 'vit_ads',
    pfm_index: positionCard,
    pfm_pos: position,
    nmOrigem: `${position}-${publication?.title}`,
  };

  return stringify(params);
};
